<div *ngIf="bookingItem$ | async; let bookingItem">

  <ub-card [rounded]="true">
    <h1 title><span i18n>Preview of {{ bookingItem.doc.name }}</span></h1>
  </ub-card>

  <mat-card appearance="outlined">
    <div i18n>Pick an option</div>
    <mat-form-field appearance="outline">
      <mat-select [formControl]="optionPicker">
        <mat-option *ngFor="let option of bookingOptions" [value]="option">{{ option.title ?? getDefaultOptionTitle() }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </mat-card>

  <mat-card appearance="outlined" *ngIf="rolePicker">
    <div i18n>State is {{ state.name }}. Pick role</div>
    <mat-form-field appearance="outline">
      <mat-select [formControl]="rolePicker">
        <mat-option *ngFor="let option of roles" [value]="option">{{ option }}</mat-option>
      </mat-select>
    </mat-form-field>
  </mat-card>

  <mat-card appearance="outlined">
    <form *ngIf="form$ | async; let form; else loading" [formGroup]="form.group.control">
      <div class="form-container">
        <eas-easform-group [easGroup]="form.group"></eas-easform-group>
      </div>
      <button mat-flat-button color="primary" type="button" *ngFor="let trans of form.transitions"
        (click)="doTransition(trans)">{{ trans.name }}</button>
      <div *ngIf="debug">
        <pre>{{ form.group.control.value | json }}</pre>
        <pre>{{ form.group.getValue() | json }}</pre>
      </div>
    </form>
    <ng-template #loading>
      <div *ngIf="!optionPicker.value || !rolePicker.value" i18n>Pick an option or role...</div>
      <div *ngIf="optionPicker.value && rolePicker.value  && !error" i18n>Loading ...</div>
      <div *ngIf="optionPicker.value && rolePicker.value && error">{{ error }}</div>
    </ng-template>
  </mat-card>

  <mat-card appearance="outlined" *ngIf="debug">
    <pre>{{ model | json }}</pre>
    <pre>{{ state | json }}</pre>
  </mat-card>


</div>
